import { render } from "./DesignHubView.vue?vue&type=template&id=af00223e&scoped=true"
import script from "./DesignHubView.vue?vue&type=script&lang=js"
export * from "./DesignHubView.vue?vue&type=script&lang=js"

import "./DesignHubView.vue?vue&type=style&index=0&id=af00223e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af00223e"]])

export default __exports__